import _slicedToArray from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { arrayify, logger } from '@sentry/utils';
import { getCurrentHub } from './hub.js';
import { addGlobalEventProcessor } from './scope.js';
var installedIntegrations = [];
/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */

function filterDuplicates(integrations) {
  var integrationsByName = {};
  integrations.forEach(function (currentInstance) {
    var name = currentInstance.name;
    var existingInstance = integrationsByName[name]; // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance

    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });
  return Object.values(integrationsByName);
}
/** Gets integrations to install */


function getIntegrationsToSetup(options) {
  var defaultIntegrations = options.defaultIntegrations || [];
  var userIntegrations = options.integrations; // We flag default instances, so that later we can tell them apart from any user-created instances of the same class

  defaultIntegrations.forEach(function (integration) {
    integration.isDefaultInstance = true;
  });
  var integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [].concat(_toConsumableArray(defaultIntegrations), _toConsumableArray(userIntegrations));
  } else if (typeof userIntegrations === 'function') {
    integrations = arrayify(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  var finalIntegrations = filterDuplicates(integrations); // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.

  var debugIndex = finalIntegrations.findIndex(function (integration) {
    return integration.name === 'Debug';
  });

  if (debugIndex !== -1) {
    var _finalIntegrations$sp = finalIntegrations.splice(debugIndex, 1),
        _finalIntegrations$sp2 = _slicedToArray(_finalIntegrations$sp, 1),
        debugInstance = _finalIntegrations$sp2[0];

    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */


function setupIntegrations(integrations) {
  var integrationIndex = {};
  integrations.forEach(function (integration) {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(addGlobalEventProcessor, getCurrentHub);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("Integration installed: ".concat(integration.name));
    }
  });
  return integrationIndex;
}

export { getIntegrationsToSetup, installedIntegrations, setupIntegrations };